<div *ngIf="loaded==1"> 
    <h6 class="ft17 ft500 mgb20">Historial de compras</h6>

    <!-- Expansion panel -->
    <mat-accordion class="fw" *ngIf="compras.length>=1 ;else noHayCompras">
        <mat-expansion-panel hideToggle *ngFor="let item of compras; let i=index" class="radius0 shadow0 border-t">
            <mat-expansion-panel-header class="backWhite radius0">
                <mat-panel-title class="fw">

                    <!-- Expansion panel header -->
                    <div fxLayout="row" fxLayoutAlign="space-between" fxFlex="100%">
                        <div fxLayout="row" fxFlex="100%">
                            <span class="w-20">{{item.transaccionFecha.toDate() | date}}</span>
                            <span class="w-70">{{item.cursoTitulo}} </span>
                        </div>
                        <div>
                            <mat-icon class="gray-6 mgl10 mgr10"  matTooltip="Descargar invoice" routerLink="/est/detalle-factura/{{item.transaccionId}}/{{usuario.uid}}">download</mat-icon>
                        </div>
                        <div>
                            <div *ngIf="item.transaccionEstatusCobro==='paid'" class="sqChip ft12 backGreen5 gray-1">
                                {{item.transaccionEstatusCobro}} </div>
                            <div *ngIf="item.transaccionEstatusCobro==='unpaid'" class="sqChip ft12 backRed5 gray-1">
                                {{item.transaccionEstatusCobro}} </div>
                        </div>
                    </div>

                </mat-panel-title>
                <mat-panel-description>

                    <!-- Total -->
                    <span class="nowrap">{{item.cursoPrecioFinal}} USD</span>

                </mat-panel-description>
            </mat-expansion-panel-header>

            <!-- Expansion panel body -->
            <div class="backLight pd10 mgb10 radius3">

                <div>
                    <span class="title">Título: </span>
                    <span>{{item.cursoTitulo}}</span>
                </div>

                <div>
                    <span class="title">Nombre del instructor: </span>
                    <span>{{item.instructorNombre}}</span>
                </div>

                <div>
                    <span class="title">Precio Original: </span>
                    <span>{{item.cursoPrecioOriginal}}</span>
                </div>

                <div *ngIf="item.cursoPorcentajeDescuento > 0" >
                    <span class="title">Descuento: </span>
                    <span>{{item.cursoPorcentajeDescuento}}%</span>
                </div>

                <div *ngIf="item.cursoPorcentajeDescuento > 0">
                    <span class="title">Precio Final: </span>
                    <span>{{item.cursoPrecioFinal}}</span>
                </div>

                <div>
                    <span class="title">Moneda: </span>
                    <span>{{item.transaccionMoneda}}</span>
                </div>

                <div>
                    <span class="title">Fecha: </span>
                    <span>{{item.transaccionFecha.toDate() | date}}</span>
                </div>

                <div>
                    <span class="title">Estatus Cobro: </span>
                    <span>{{item.transaccionEstatusCobro}}</span>
                </div>

                <div>
                    <span class="title">Via cobro: </span>
                    <span>{{item.transaccionViaCobro}}</span>
                </div>

                <div>
                    <span class="title">Transaccion Id: </span>
                    <span>{{item.transaccionId}}</span>
                </div>

                <div class="mgt05">
                    <a class="blueLink ft12 ft500" routerLink="/est/detalle-factura/{{item.transaccionId}}/{{usuario.uid}}">Descargar invoice</a>
                </div>

            </div>

        </mat-expansion-panel>
    </mat-accordion>

    <ng-template #noHayCompras>
        <p>No has realizado ninguna compra hasta ahora.</p>
    </ng-template>

</div>

<div *ngIf="loaded==0">
    <div *ssrExclude>
        <spinner></spinner>
    </div>
</div>